import {jarallax, jarallaxVideo} from "jarallax";

jarallaxVideo();
jarallax(document.querySelectorAll(".jarallax"));
